<template>
  <div id="app">
    <custom-header :links="videoseiten_menu" :main_menu="main_menu" :menu_content="menu_content"></custom-header>
    <template v-if="typeof page === 'undefined'">
      <front-page :videopages="videoseiten_menu"></front-page>
    </template>
    <template v-else-if="typeof page != 'undefined' && page.__typename === 'NodePage'">
      <video-page :page="page" :contact_block="contact_block" :bottom_navigation="video_pages"></video-page>
    </template>
    <template v-else-if="typeof page != 'undefined' && page.__typename === 'NodeContentPage'">
      <content-page :page="page" :sprachen="sprecher_sprachen"></content-page>
    </template>
    <template v-else-if="typeof page != 'undefined' && page.__typename === 'NodeKundenseite'">
      <kundenseite :page="page" :contact_block="contact_block"></kundenseite>
    </template>
    <custom-footer :page="pageType" :slogan="slogan" :links="videoseiten_menu" :social="socialmedia_menu" :copyright="copyright" :meta_nav="footer_menu"></custom-footer>
  </div>
</template>

<script>
  import page from './apollo/queries/page.gql';
  import sprachen from './apollo/queries/sprachen.gql';
  import mainMenu from './apollo/queries/mainMenu.gql';
  import footer from './apollo/queries/footer.gql';
  import videoseitenMenu from './apollo/queries/videoseitenMenu.gql';
  import menuContent from './apollo/queries/menuContent.gql';
  import socialmediaMenu from './apollo/queries/socialmediaMenu.gql';
  import copyright from './apollo/queries/copyright.gql';
  import footerMenu from './apollo/queries/footerMenu.gql';

  import $ from 'jquery';

  export default {
    name: 'App',
    components: {
      'custom-header': () => import('./components/molecules/CustomHeader'),
      'video-page': () => import('./components/pages/VideoPage'),
      'content-page': () => import('./components/pages/ContentPage'),
      'front-page': () => import('./components/pages/FrontPage'),
      'kundenseite': () => import('./components/pages/Kundenseite'),
      'custom-footer': () => import('./components/molecules/CustomFooter'),
    },
    data() {
      return {
        page: {},
        video_pages: {},
        main_menu: {},
        slogan: {},
        sprecher_sprachen: {},
        videoseiten_menu: {},
        menu_content: {},
        socialmedia_menu: {},
        copyright: {},
        footer_menu: {},
        loading: true,
      }
    },
    apollo: {
      page: {
        prefetch: ({route}) => ({path: window.location.pathname}),
        query: page,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          var langID = this.$cookies.get('zdpLangCode') ? this.$cookies.get('zdpLangCode') : ((navigator.language
              || navigator.userLanguage).toString().indexOf('de') < 0 ? 'EN' : 'DE');
          return {path: window.location.pathname, language: langID};
        },
        update(data) {
          return data.nodeQuery.entities[0];
        }
      },
      main_menu: {
        prefetch: true,
        query: mainMenu,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          var langID = this.$cookies.get('zdpLangCode') ? this.$cookies.get('zdpLangCode') : ((navigator.language
              || navigator.userLanguage).toString().indexOf('de') < 0 ? 'EN' : 'DE');
          return {language: langID};
        },
        update(data) {
          let links = data.menuByName.links.map(element => {
            element.url.path = element.url.path.replace('/backend', '');
            return element;
          });
          return links;
        }
      },
      slogan: {
        prefetch: true,
        query: footer,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          var langID = this.$cookies.get('zdpLangCode') ? this.$cookies.get('zdpLangCode') : ((navigator.language
              || navigator.userLanguage).toString().indexOf('de') < 0 ? 'EN' : 'DE');
          return {language: langID};
        },
        update(data) {
          return data.nodeQuery.entities[0].fieldSlogan;
        }
      },
      sprecher_sprachen: {
        prefetch: true,
        query: sprachen,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          var langID = this.$cookies.get('zdpLangCode') ? this.$cookies.get('zdpLangCode') : ((navigator.language
              || navigator.userLanguage).toString().indexOf('de') < 0 ? 'EN' : 'DE');
          return {language: langID};
        },
        update(data) {
          return data.taxonomyTermQuery.entities;
        }
      },
      videoseiten_menu: {
        prefetch: true,
        query: videoseitenMenu,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          var langID = this.$cookies.get('zdpLangCode') ? this.$cookies.get('zdpLangCode') : ((navigator.language
              || navigator.userLanguage).toString().indexOf('de') < 0 ? 'EN' : 'DE');
          return {language: langID};
        },
        update(data) {
          let links = data.menuByName.links.map(element => {
            element.url.path = element.url.path.replace('/backend', '');
            return element;
          });
          return links;
        }
      },
      menu_content: {
        prefetch: true,
        query: menuContent,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          var langID = this.$cookies.get('zdpLangCode') ? this.$cookies.get('zdpLangCode') : ((navigator.language
              || navigator.userLanguage).toString().indexOf('de') < 0 ? 'EN' : 'DE');
          return {language: langID};
        },
        update(data) {
          return data.nodeQuery.entities;
        }
      },
      socialmedia_menu: {
        prefetch: true,
        query: socialmediaMenu,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          var langID = this.$cookies.get('zdpLangCode') ? this.$cookies.get('zdpLangCode') : ((navigator.language
              || navigator.userLanguage).toString().indexOf('de') < 0 ? 'EN' : 'DE');
          return {language: langID};
        },
        update(data) {
          let links = data.menuByName.links.map(element => {
            element.url.path = element.url.path.replace('/backend', '');
            return element;
          });
          return links;
        }
      },
      copyright: {
        prefetch: true,
        query: copyright,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          var langID = this.$cookies.get('zdpLangCode') ? this.$cookies.get('zdpLangCode') : ((navigator.language
              || navigator.userLanguage).toString().indexOf('de') < 0 ? 'EN' : 'DE');
          return {language: langID};
        },
        update(data) {
          return data.nodeQuery.entities[0].fieldCopyright;
        }
      },
      footer_menu: {
        prefetch: true,
        query: footerMenu,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          var langID = this.$cookies.get('zdpLangCode') ? this.$cookies.get('zdpLangCode') : ((navigator.language
              || navigator.userLanguage).toString().indexOf('de') < 0 ? 'EN' : 'DE');
          return {language: langID};
        },
        update(data) {
          let links = data.menuByName.links.map(element => {
            element.url.path = element.url.path.replace('/backend', '');
            return element;
          });
          return links;
        }
      }
    },
    computed: {
      pageType: function() {
        return this.page != undefined ? this.page.__typename : 'other';
      },
    },
    created() {
      if(this.$cookies.get('zdpLangCode')) {
        this.$store.commit('setLanguage', this.$cookies.get('zdpLangCode'));
        this.$i18n.locale = this.$store.state.language.toLowerCase();
      }
    },
    mounted() {
      $(window).on('scroll resize', function() {
        $('.text-fade-in').each(function() {
          if($(this).isInViewport()) {
            $(this).addClass('fade-in');
          }
        });
        $('.section-fade-in').each(function() {
          if($(this).isInViewport()) {
            $(this).addClass('fade-in');
          }
        });
        $('.element-fade-in').each(function() {
          if($(this).isInViewport()) {
              $(this).addClass('fade-in');
          }
        });
      });

      $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top + 250;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      };
    },
  }
</script>

<style lang="scss">
  @import "assets/scss/variables/custom_variables";
  @import "assets/scss/variables/bootstrap_overwrites";

  body {
    background-color: black;
    color: white;
    scroll-behavior: smooth;
    margin: 0;
    padding: 0;
    &.menu-open {
      overflow: hidden;
    }
  }

  .cc-window, .cc-revoke {
    font-family: $font-family-sans-serif;
  }
  .cc-holder {
    background: $dark !important;
    color: white !important;
    .cc-link {
      color: white !important;
    }

  }
  .cc-window.cc-floating.cc-center .cc-background {
    opacity: 0.6;
  }
  .cc-window.cc-type-categories {
    .cc-savebuttons {
      .cc-btn {
        border-radius: 50px;
        color: black !important;
        background: $primary !important;
        border-color: $primary !important;
        padding: 1em 2em;
        font-family: $headings-font-family;
        font-weight: normal;
        &.cc-save {
          color:$primary  !important;
          background: transparent !important;
        }
      }
    }
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

</style>
